//src/api/interceptors/authInterceptors.ts
import type { FetchOptions } from '@/types/shared/api.types';
import { getSessionToken } from '@/utils/sessionStorage';

export const authRequestInterceptor = (options: FetchOptions): FetchOptions => {
  const token = getSessionToken();
  const headers = { ...(options.headers ?? {}) };
  if ((token !== null) && token.trim() !== '') {
    headers.Authorization = `Bearer ${token}`;
  }
  const mergedOptions: FetchOptions = {
    ...options,
    headers
  };
  return mergedOptions;
};

const HTTP_STATUS_UNAUTHORIZED = 401;

export const authResponseInterceptor = (response: Response): Response => {
  if (response.status === HTTP_STATUS_UNAUTHORIZED) {
    const currentPath = window.location.pathname;
    const isAuthRoute =
      currentPath.startsWith('/login') ||
      currentPath.startsWith('/registration');

    if (!isAuthRoute) {
      window.location.href = '/login';
    }
  }
  return response;
};
